import React from 'react';
import bundle from '../../assets/bundle.png';

function BundleSection({ bundleCovers, onChooseDigitalBundle, onPreorderPaperBundle }) {
  return (
    <section className="bundle-section">
      <h1 className="order-title">
        <span>Choose Your Bundle</span>
        <img src={bundle} alt="Bundle" className="order-title-icon" />
      </h1>
      <p className="bundle-subtitle">Get both books in the same format and save 🎁</p>
      <div className="bundle-grid">
        <div className="bundle-box digital">
          <div className="bundle-stripe" />
          <div className="bundle-inner">
            <div className="bundle-books">
              <img src={bundleCovers.digital[0]} alt="Book 1" />
              <img src={bundleCovers.digital[1]} alt="Book 2" />
            </div>
            <h3>Digital Bundle</h3>
            <div className="bundle-price-bar">
              <div className="price-row">
                <span className="old-price">1400 DA</span>
                <span className="new-price">1100 DA</span>
              </div>
            </div>
            <button type="button" className="bundle-btn" onClick={onChooseDigitalBundle}>
              Choose Digital
            </button>
          </div>
        </div>

        <div className="bundle-box paper coming-soon-bundle">
          <div className="bundle-stripe" />
          <span className="coming-soon-badge-corner">Coming Soon</span>
          <div className="bundle-inner">
            <div className="bundle-books">
              <img src={bundleCovers.paper[0]} alt="Book 1" />
              <img src={bundleCovers.paper[1]} alt="Book 2" />
            </div>
            <h3>Paperback Bundle</h3>
            <div className="bundle-price-bar">
              <div className="price-row">
                <span className="old-price">3500 DA</span>
                <span className="new-price">2700 DA</span>
              </div>
            </div>
            <button type="button" className="bundle-btn" onClick={onPreorderPaperBundle}>
              Notify me when it's ready 🔔
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BundleSection;